import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  version?: string;
  customerNumber?: string;
}

export const CustomerInfo: FC<Props> = ({ version, customerNumber }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-xs text-white text-opacity-75">
      {customerNumber && (
        <span className="flex">
          {t("Footer.customerNumber")} {customerNumber}
        </span>
      )}
      <span className="flex">
        {t("Footer.version")} {version}
      </span>
    </div>
  );
};
